var url = require('url');
var http = require('http');

import {WMS} from './wms';
import {WFS} from './wfs';
import {updateLayersDate} from './index';

// jQuery UI slider
// TODO: convert to ES6 class
function Slider(dom_id=""){
	var that = this;
	this.dom_id = dom_id;
	this.slider = new Object();
	this.lastDate = new Date();	// date of last displayed layer
	
	
	/*
    TODO: - določi datum min in datum max, poveži slider s kontrolo za izbiro datuma (izbira na datum kontroli spremeni slider, izbira na sliderju spremeni datum), posodobi datum slojev
  */
  if(dom_id != ""){
	  	  
	  $.removeData($(dom_id).get(0));
	  
	  $(dom_id).text("Waiting for data...");
	  $(dom_id).html('<div id="custom-handle" class="ui-slider-handle"></div>');
	  
	  // prepare jquery ui progressbar
	  $("#slider-wait").progressbar({
		  value:false
	  }).hide();
	  
	  // izdelaj objekt z datumi možnih posnetkov za tekoče leto
		// pridobi jih z ustrezno WMS poizvedbo
		//var WMSlocal = new WMS();
		
		// TODO get dates from datapickers
		var time = this.dateFromPickers();
		
		//WMSlocal.data("WMS_slider");
		if(typeof(time === "undefined")){
			var date1 = new Date();
			var date2 = new Date();
			date2.setDate(date1.getDate() - 30);	// one month
			time = date2.getFullYear()+"-"+(date2.getMonth()+1)+"-"+date2.getDate()+"/"+date1.getFullYear()+"-"+(date1.getMonth()+1)+"-"+date1.getDate();
		}
						
		//WMSlocal.data("WMS_slider",{"TIME":time});
		
		var WFSlocal = new WFS();
		WFSlocal.data("WFS_slider",{"TIME":time},that.loadData.bind(this),that.updateData.bind(this));
		
		/*
		$(document).on("WMS_slider", function(results, data){
			that.loadData(data);
		});
		*/
  }
}

Slider.prototype.loadData = function(data){
	if(data.constructor === Array){	
		var max = data.length;
		let rdata = data.reverse();
		
		let cdi = this.closestDate(rdata);	// get last layer date selected
				
		this.createScale(rdata,max,cdi);
		
		$("#current_date_display").text(rdata[cdi]);
								
		this.slider = $(this.dom_id).slider({
		//range: "max",
		value: cdi,
		min: 0,
		max: rdata.length-1,
		step: 1,
		slide: function( event, ui ) {
		  //TODO: posodobi datum kontrolo
		  $("#current_date_display").text(rdata[ui.value]);		  
		  $(".scale_item").css("font-weight","normal");
		  $(".scale"+ui.value).css("font-weight","bold");
		  updateLayersDate(rdata[ui.value]);
		}
		});
		
		
		// update layer date
		updateLayersDate(rdata[cdi]);
		
		this.wait(false);
	};
}

Slider.prototype.createScale = function(data,max,value){
	// vrednosti razdeli po li elementih	
	let ul = $("<ul>").attr("id", "ul");
	
	//let fix = (max > 7)?360:420;	
	let fix = (max > 7)?310:360;	
	let luft = fix/max;
			
	for(var key in data){
		let li = $("<p>").text(data[key])
							.css("left",(luft*key))
							.attr("class","scale"+key+" scale_item");
		ul.append(li);
	}
		
	$("#data-slider-scale").html(ul);
	$(".scale"+value).css("font-weight","bold");		
}

Slider.prototype.updateData = function(data){
	this.slider.slider("option", "max", data.length-1);
}

Slider.prototype.dateFromPickers = function(){
	var date1 = $( "#date-picker1" ).val();
	var date2 = $( "#date-picker2" ).val();
	
	date1 = date1.split("/");
	date2 = date2.split("/");
	
	// izpiši na roke, ker moraš itak zamenjati vrstni red
	return date1[2]+"-"+date1[0]+"-"+date1[1]+"/"+date2[2]+"-"+date2[0]+"-"+date2[1];
	
}

Slider.prototype.reload = function(settings){
	var that = this;
	var time = this.dateFromPickers();
	this.wait(true);
	
	const query = {"TIME":time};
	const merge = Object.assign(query, settings);
	
	if(settings != null){
		var WFSlocal = new WFS();
		WFSlocal.data("WFS_slider",merge,that.loadData.bind(this),that.updateData.bind(this));
	}else{
		var WFSlocal = new WFS();
		WFSlocal.data("WFS_slider",merge,that.loadData.bind(this),that.updateData.bind(this));
		/*
		var WMSlocal = new WMS();
		WMSlocal.data("WMS_slider",merge);
			
	
		$(document).on("WMS_slider", function(results, data){
			that.updateData(data);
		});
		*/
	}	
}

Slider.prototype.wait = function(toggle){
	if(toggle){
		$(this.dom_id).hide();
		$("#data-slider-scale").hide();
		//$("#current_date_display").hide();
		$("#slider-wait").show();
	}else{
		$(this.dom_id).show();
		$("#data-slider-scale").show();
		//$("#current_date_display").show();
		$("#slider-wait").hide();
	}
}

// set last date attribute
Slider.prototype.setLastDate = function(date){
	this.lastDate = date;
}

// return closest date in array
Slider.prototype.closestDate = function(dates){
	let shortest = [-1,Number.MAX_VALUE];
	for(let i in dates){
		let date1 = new Date(dates[i]);
		if(Math.abs(this.lastDate - date1) < (shortest[1])){
			shortest[0] = i;
			shortest[1] = Math.abs(date1 - this.lastDate);
		}
	}
	return shortest[0];
}
		
export {Slider};